import { type RecentlyDeletedItemType } from '~/components/RecentlyDeleted/types';

export const DELETED_ITEM_TYPES: {
  id: RecentlyDeletedItemType;
  label: string;
}[] = [
  {
    id: 'library',
    label: 'Libraries',
  },
  {
    id: 'board',
    label: 'Boards',
  },
  {
    id: 'asset',
    label: 'Assets',
  },
  {
    id: 'customField',
    label: 'Custom fields',
  },
];
